export default __webpack_public_path__ + "static/media/102-icon.98aa5b09.svg";